import React from 'react';
import PropTypes from 'prop-types';
import {
  Tab,
  TabContent,
  TabContentGroup,
  TabGroup,
  TabMenu,
} from '@americanexpress/dls-react';
import { FxComponentWrapper } from '../FxComponentUtils/FxComponentWrapper';

export const FxTabContainer = ({
  tabs,
  defaultSelectedTab,
  selectedTab,
  handleOnTabChange,
}) => {
  const tabMenuTheme = tabs.length < 2 ? { display: 'none' } : null;
  return (
    <TabGroup
      defaultSelectedTab={defaultSelectedTab}
      selectedTab={selectedTab}
      onChange={handleOnTabChange}
    >
      <TabMenu theme={tabMenuTheme}>
        {tabs.map((tab) => (
          <Tab key={tab.id} id={tab.id} contentId={tab.id}>
            {tab.name}
          </Tab>
        ))}
      </TabMenu>
      <TabContentGroup>
        {tabs.map((tab) => (
          <TabContent key={tab.id} labelledBy={tab.id}>
            <FxComponentWrapper
              loadedComponent={tab.content}
              isError={tab.isError}
              isLoading={tab.isLoading}
            />
          </TabContent>
        ))}
      </TabContentGroup>
    </TabGroup>
  );
};

FxTabContainer.propTypes = {
  tabs: PropTypes.arrayOf({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
  }),
  defaultSelectedTab: PropTypes.string,
  selectedTab: PropTypes.string,
  handleOnTabChange: PropTypes.func,
};

FxTabContainer.defaultProps = {
  defaultSelectedTab: null,
  selectedTab: null,
  handleOnTabChange: null,
};
